module.exports = __webpack_public_path__ + "img/TO.56d24ac5.svg";